import {ErrorTypes} from './ErrorUtils';

import {
  APIErrorCodes,
  APIFormErrorCodes,
  MAXIMUM_ALLOWED_COMPANIES,
  MAXIMUM_ALLOWED_TEAMS,
} from '@developers/Constants';
import {Messages} from '@developers/i18n';
import type {FormattedMessage} from '@discordapp/i18n';

type ErrorMappings = Record<
  keyof typeof ErrorTypes,
  Record<Values<typeof APIErrorCodes>, string | null | FormattedMessage<Record<string, unknown>>>
>;

// ErrorTypes besides COMMON should only be used for handling error codes with multiple potential
// use cases that need section-specific messages.
export const getErrorCodeMappings = (): ErrorMappings => {
  return {
    [ErrorTypes.COMMON]: {
      [APIErrorCodes.INVALID_APPLICATION_NAME]: Messages.SKU_MANAGEMENT_DUPLICATE_APPLICATION_NAME,
      [APIErrorCodes.TOO_MANY_APPLICATION_GAME_SKUS]: Messages.SKU_MANAGEMENT_TOO_MANY_APPLICATION_GAME_SKUS,
      [APIErrorCodes.TOO_MANY_TEAMS]: Messages.TEAMS_TOO_MANY_TEAMS.format({maxTeams: MAXIMUM_ALLOWED_TEAMS}),
      [APIErrorCodes.TEAM_MEMBER_ALREADY_EXISTS]: Messages.TEAMS_TEAM_MEMBER_ALREADY_EXISTS,
      [APIErrorCodes.INVALID_MFA_CODE]: Messages.COMMON_INVALID_MFA_CODE,
      [APIErrorCodes.TEAM_MEMBERS_MUST_BE_VERIFIED]: Messages.TEAMS_TEAM_MEMBERS_MUST_BE_VERIFIED,
      [APIErrorCodes.TEAM_OWNERSHIP_REQUIRED]: Messages.TEAMS_TEAM_OWNER_ONLY,
      [APIErrorCodes.TEAM_INVITATION_ALREADY_ACCEPTED]: Messages.TEAMS_INVITATION_ALREADY_ACCEPTED,
      [APIErrorCodes.UNKNOWN_TEAM]: Messages.TEAMS_UNKNOWN_TEAM_ERROR,
      [APIErrorCodes.UNKNOWN_TEAM_MEMBER]: Messages.TEAMS_UNKNOWN_TEAM_MEMBER_ERROR,
      [APIErrorCodes.TOO_MANY_COMPANIES]: Messages.METADATA_MAX_COMPANIES_REACHED.format({
        maxCompanies: MAXIMUM_ALLOWED_COMPANIES,
      }),
      [APIErrorCodes.MFA_REQUIRED]: Messages.COMMON_TWO_FACTOR_AUTHENTICATION_REQUIRED,
      [APIErrorCodes.TERMS_OF_SERVICE_REQUIRED]: Messages.COMMON_APPLICATION_VERIFICATION_INVALID_TOS_EMPTY,
      [APIErrorCodes.PRIVACY_POLICY_REQUIRED]: Messages.COMMON_APPLICATION_VERIFICATION_INVALID_PRIVACY_POLICY_EMPTY,
    },
    [ErrorTypes.TEAMS]: {
      [APIErrorCodes.INVALID_TOKEN]: Messages.TEAMS_INVALID_INVITE_TOKEN,
      [APIErrorCodes.UNKNOWN_USER]: Messages.TEAMS_UNKNOWN_USER,
      [APIErrorCodes.INVALID_ACCOUNT_TYPE]: Messages.TEAMS_INVALID_ACCOUNT_TYPE,
    },
    [ErrorTypes.FORMS]: {
      [APIFormErrorCodes.APPLICATION_VERIFICATION_DISABLED]:
        Messages.COMMON_APPLICATION_VERIFICATION_DISABLED_HOLIDAY_BREAK,
    },
  };
};
